const receiver = new BroadcastChannel("athena_channel");
receiver.addEventListener("message", ({ data }) => data == "refresh_page" && location.reload());
receiver.addEventListener("message", ({ data }) => data == "home_page" && location.assign("/"));

const emitter = new BroadcastChannel("athena_channel");
export const refresh = () => emitter.postMessage("refresh_page");
export const homepage = () => emitter.postMessage("home_page");

window.bcRefresh = refresh;
window.bcHomepage = homepage;
